export default __webpack_public_path__ + "static/media/plus.490c1fde.svg";